module.exports = __webpack_public_path__ + "img/Final Model V4.4bac6ed5.jpg";